module.exports = __webpack_public_path__ + "img/itch-io.75706ff0.png";